var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSavingBalance = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF7E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 12.1598C31.2 14.0155 29.6957 15.5198 27.84 15.5198C25.9843 15.5198 24.48 14.0155 24.48 12.1598C24.48 10.3041 25.9843 8.7998 27.84 8.7998C29.6957 8.7998 31.2 10.3041 31.2 12.1598Z",
    fill: "url(#paint0_linear_7866_19312)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 8.7998C21.5664 8.7998 22.9006 8.7998 24.0452 8.84266C23.2697 9.72904 22.7998 10.8895 22.7998 12.1598C22.7998 14.9433 25.0563 17.1998 27.8398 17.1998C29.1101 17.1998 30.2706 16.7299 31.157 15.9544C31.1998 17.099 31.1998 18.4332 31.1998 19.9998C31.1998 25.2795 31.1998 27.9194 29.5596 29.5596C27.9194 31.1998 25.2795 31.1998 19.9998 31.1998C14.7201 31.1998 12.0802 31.1998 10.44 29.5596C8.7998 27.9194 8.7998 25.2795 8.7998 19.9998C8.7998 14.7201 8.7998 12.0802 10.44 10.44C12.0802 8.7998 14.7201 8.7998 19.9998 8.7998ZM22.7998 18.5998C22.3359 18.5998 21.9598 18.2237 21.9598 17.7598C21.9598 17.2959 22.3359 16.9198 22.7998 16.9198H25.5998C26.0637 16.9198 26.4398 17.2959 26.4398 17.7598V20.5598C26.4398 21.0237 26.0637 21.3998 25.5998 21.3998C25.1359 21.3998 24.7598 21.0237 24.7598 20.5598V19.7877L22.5057 22.0418C21.7403 22.8072 20.4993 22.8072 19.7339 22.0418L17.9578 20.2657C17.8484 20.1564 17.6712 20.1564 17.5618 20.2657L14.9938 22.8338C14.6657 23.1618 14.1339 23.1618 13.8058 22.8338C13.4778 22.5057 13.4778 21.9739 13.8058 21.6458L16.3739 19.0778C17.1393 18.3124 18.3803 18.3124 19.1457 19.0778L20.9218 20.8539C21.0312 20.9632 21.2084 20.9632 21.3178 20.8539L23.5719 18.5998H22.7998Z",
    fill: "url(#paint1_linear_7866_19312)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7866_19312",
    x1: 24.48,
    y1: 8.7998,
    x2: 31.2,
    y2: 15.5198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F6932B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7866_19312",
    x1: 8.7998,
    y1: 8.7998,
    x2: 31.1998,
    y2: 31.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F6932B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16601"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSavingBalance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SavingBalance.59ddb291.svg";
export { ForwardRef as ReactComponent };